import React from "react";

const STATUS_STYLES = {
  // QC / stock statuses
  "Waiting QC": "bg-slate-100 text-slate-700 border-slate-200",
  "Menunggu QC": "bg-slate-100 text-slate-700 border-slate-200",
  "QC In Progress": "bg-amber-50 text-amber-700 border-amber-200",
  "Passed": "bg-green-50 text-green-700 border-green-200",
  "QC Passed": "bg-green-50 text-green-700 border-green-200",
  "Ready for POS Import": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Imported to POS": "bg-cocoa/10 text-cocoa border-cocoa/20",
  "Rework": "bg-orange-50 text-orange-600 border-orange-200",
  "Rejected": "bg-red-50 text-red-600 border-red-200",
  "Reject": "bg-red-50 text-red-600 border-red-200",
  // receiving / import
  "Draft": "bg-slate-100 text-slate-600 border-slate-200",
  "Received": "bg-blue-50 text-blue-700 border-blue-200",
  "QC Process": "bg-amber-50 text-amber-700 border-amber-200",
  "Completed": "bg-green-50 text-green-700 border-green-200",
  "Cancelled": "bg-red-50 text-red-500 border-red-200",
  "Imported": "bg-cocoa/10 text-cocoa border-cocoa/20",
  // transfer
  "Approved": "bg-blue-50 text-blue-700 border-blue-200",
  "Picking": "bg-amber-50 text-amber-700 border-amber-200",
  "In Transit": "bg-blue-50 text-blue-600 border-blue-200",
  "Discrepancy": "bg-orange-50 text-orange-600 border-orange-200",
};

export function StatusBadge({ status }) {
  const cls = STATUS_STYLES[status] || "bg-taupe/15 text-cocoa border-taupe/30";
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${cls}`}
    >
      {status}
    </span>
  );
}

export function PageHeader({ title, subtitle, children, testId }) {
  return (
    <div className="flex flex-col sm:flex-row sm:flex-wrap sm:items-end sm:justify-between gap-3 sm:gap-4 mb-6" data-testid={testId}>
      <div>
        <h1 className="text-2xl sm:text-3xl font-heading font-bold tracking-tight text-cocoa">{title}</h1>
        {subtitle && <p className="text-sm text-wmuted mt-1">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-2 flex-wrap">{children}</div>
    </div>
  );
}

export function Panel({ children, className = "", ...rest }) {
  return (
    <div className={`bg-white border border-taupe/20 rounded-lg overflow-x-auto ${className}`} {...rest}>{children}</div>
  );
}
